import { Select } from 'antd'
import { Form } from 'antd'
import { FC } from 'react'
import { requiredOneElementRules } from '../../../../../../../../../../constants/forms/validation/rules'
import { formatRollerDisplay } from '../../../../../../../../../../helpers/format-roller-display'
import { useGetRollersQuery } from '../../../../../../../../../../store/api/rollers-api'


interface RollerProps {}

const Roller: FC<RollerProps> = () => {
    const name = 'roller'

    const { data } = useGetRollersQuery()

    return (
        <Form.Item name={name} label={'Вал'} rules={requiredOneElementRules}>
            <Select
                options={data?.data.map(item => ({
                    value: item.documentId,
                    label: formatRollerDisplay(item.roller),
                }))}
            />
        </Form.Item>
    )
}

export default Roller
